import config from '../config/config'
import axios from 'axios'
// import store from '../store/store'
// import { SET_SNACKBAR } from '../store/mutations'

var IO = require('@pm2/js-api')

const mappings = require('@pm2/js-api/src/api_mappings.json')

let io

export function init () {
  return new Promise(async (resolve, reject) => {
    const curRes = await axios(`${process.env.API_URL}/api/backoffice/currencies.json`)
    window.currencies = curRes.data

    const res = await axios(`${process.env.API_URL}/api/backoffice/backoffice_mappings.json`)
    mappings.backoffice = res.data

    io = new IO({
      OAUTH_CLIENT_ID: window.OAUTH_CLIENT_ID || config.OAUTH_CLIENT_ID,
      services: {
        OAUTH: config.OAUTH_URL,
        API: config.KM_API,
        BACKOFFICE: process.env.API_URL || ''
      },
      mappings
    }).use('browser')
    window.io = io

    io._network._axios.interceptors.response.use(
      res => {
        return res
      },
      err => {
        return Promise.reject(err)
      }
    )

    return resolve()
  })
}

export function getAccessToken () {
  return window.io._network.tokens.access_token
}

export function reauthenticate (callback) {
  window.io._network.oauth_flow.retrieveTokens(io, (err, data) => {
    // if it fail, we fail the whole request
    if (err) {
      callback(err)
      return io._network.oauth_flow.deleteTokens(io)
    }
    // if its good, we try to update the tokens
    io._network._updateTokens(null, data, (err, authenticated) => {
      // if it fail, we fail the whole request
      if (err) {
        callback(err)
        return io._network.oauth_flow.deleteTokens(io)
      }
      callback()
    })
  })
}

export default io
